import { ActionType } from 'deox';
import { SagaIterator } from 'redux-saga';
import { put, takeLatest } from 'redux-saga/effects';

import { processRequestError } from './actions';

function* processRequestErrorSaga({
  payload: { error, failAction },
}: ActionType<typeof processRequestError>): SagaIterator {
  let errorText = '';

  if (error.response) {
    switch (error.response.status) {
      case 400:
      case 403:
      case 404:
      case 409: {
        const { data } = error.response;
        if (data.detail) {
          errorText = data.detail;
        }
        break;
      }
      case 500:
      case 502:
      default: {
        errorText = 'Server error';
        break;
      }
    }
  } else if (error.request) {
    if (error.request.status === 0) {
      errorText = 'Network error';
    }
  } else {
    errorText = 'Something went wrong';
  }
  yield put(failAction(errorText));
}

export function* errorsSaga(): SagaIterator {
  yield takeLatest(processRequestError, processRequestErrorSaga);
}
